var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-965 -337)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.313 -1.312)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 10,
    transform: "translate(973.312 340.312)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 10,
    transform: "translate(968.312 345.312)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 14,
    height: 14,
    transform: "translate(965 337)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhiteIcon);
export default __webpack_public_path__ + "static/media/plus-white-icon.0eb1ad2d8f0c1f42118c9ddea603f2ed.svg";
export { ForwardRef as ReactComponent };